const $ = jQuery.noConflict();
'use strict';

const accordionDisciplines = {

	init: function() {
		this.initDisciplines();
	},

	initDisciplines: function() {
		$('.js-current-discipline-acc-details').slideUp(350);
		$('.js-current-discipline-acc-details').css('display', 'none');
		$('.js-current-discipline-acc-btn').on('click', function() {
			// e.preventDefault();
			const $this = $(this);
			const thisItem = $(this).parent().next();
			const details = $this.parent().parent().parent().siblings().find('.js-current-discipline-acc-details');

			if (thisItem.hasClass('show')) {
				thisItem.removeClass('show');
				thisItem.slideUp(350);
				$this.removeClass('active');
				$this.parent().removeClass('active');
			} else {
				details.slideUp(350);
				details.removeClass('show');
				$this.parent().parent().parent().siblings().find('.current-discipline__main-info').removeClass('active');
				thisItem.addClass('show');
				thisItem.slideDown(350);
				$this.parent().addClass('active');
				$this.parent().parent().parent().siblings().find('.js-current-discipline-acc-btn').removeClass('active');
				$this.addClass('active');
			}
		});
	}
};

export default accordionDisciplines;
